import React from 'react';
import { FieldArrayRenderProps, FormikProps } from 'formik';
import { Button } from 'antd';
import cx from 'classnames';

import TimesheetApproverSection, {
  TimesheetApproverFormValues,
} from '../TimesheetApproverSection/TimesheetApproverSection';
import { CustomerInfoFormValues } from '../CustomerInfo';

import styles from './TimeSheetApproverFieldArray.module.less';

const MAX_TIMESHEET_APPROVERS_LENGTH = 5;

const isAddTimesheetApproverButtonVisible = (
  timesheetApprovers: Array<TimesheetApproverFormValues>,
  index: number,
) =>
  timesheetApprovers.length < MAX_TIMESHEET_APPROVERS_LENGTH &&
  index === timesheetApprovers.length - 1;

interface RemoveTimesheetApproverOptions {
  timesheetApprovers: Array<TimesheetApproverFormValues>;
  sameAsSupervisor: boolean;
  index: number;
}
const isRemoveTimesheetApproverButtonVisible = (
  options: RemoveTimesheetApproverOptions,
) => {
  const { index, timesheetApprovers, sameAsSupervisor } = options;

  // Not posible to remove first section if sameAsSupervisor is checked
  if (index === 0 && sameAsSupervisor) return false;

  return timesheetApprovers.length > 1;
};

const TimeSheetApproverFieldArray = (props: FieldArrayRenderProps) => {
  const { timesheetApproverInfo, generalInfo } = (
    props.form as FormikProps<CustomerInfoFormValues>
  ).values;
  const { timesheetApprovers, sameAsSupervisor, notApplicable } =
    timesheetApproverInfo;

  const isSectionDisabled = (index: number) => {
    // Disable first section if sameAsSupervisor is checked
    if (index === 0 && sameAsSupervisor) return true;

    return !generalInfo.customer || notApplicable;
  };

  return (
    <>
      {timesheetApprovers.length > 0 &&
        timesheetApprovers.map(
          (timesheetApprover: TimesheetApproverFormValues, index: number) => (
            <React.Fragment key={index}>
              <TimesheetApproverSection
                disabled={isSectionDisabled(index)}
                formik={props.form}
                index={index}
                isFirstTimesheetApprover={index === 0}
                formNamePrefix={props.name}
                actionButtons={
                  <>
                    {!!props.form.values.generalInfo.customer &&
                      !props.form.values.timesheetApproverInfo
                        .notApplicable && (
                        <>
                          {isAddTimesheetApproverButtonVisible(
                            timesheetApprovers,
                            index,
                          ) && (
                            <Button
                              className={cx('borderless-btn', styles.btn)}
                              onClick={() =>
                                props.push({
                                  firstName: '',
                                  lastName: '',
                                  email: '',
                                  phone: '',
                                })
                              }
                              icon={
                                <span className="icon icon-plus-filled"></span>
                              }
                            />
                          )}

                          {isRemoveTimesheetApproverButtonVisible({
                            timesheetApprovers,
                            sameAsSupervisor,
                            index,
                          }) && (
                            <Button
                              className={cx('borderless-btn', styles.btn)}
                              onClick={() => props.remove(index)}
                              icon={
                                <span className="icon icon-closed-filled" />
                              }
                            />
                          )}
                        </>
                      )}
                  </>
                }
              />
            </React.Fragment>
          ),
        )}
    </>
  );
};

export default TimeSheetApproverFieldArray;
